// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface MagicWandIconSignature {
  Element: SVGSVGElement;
}

export const MagicWandIcon: TOC<MagicWandIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5763 2L13.6108 5.86303L11.6788 6.38043L10.6443 2.5174L12.5763 2ZM17.8042 10.0549L17.2866 11.9867L21.1502 13.0219L21.6678 11.0901L17.8042 10.0549ZM13.7511 14.1083L14.7861 17.9709L16.7179 17.4533L15.6829 13.5907L13.7511 14.1083ZM10.0761 7.98211L6.21213 6.94811L5.69539 8.87915L9.55939 9.91315L10.0761 7.98211ZM2 19.5167L13.3129 8.20381L15.4342 10.3251L4.1213 21.638L2 19.5167ZM18.6309 3.62162L15.8021 6.44962L17.2161 7.86402L20.0449 5.03602L18.6309 3.62162Z"/>
</svg>
</template>;